import { ITaxesMenuItemState } from "../types";
import { SET_SELECTED_LIST, SET_MENU_ITEM_LIST, SET_FILTERS_STATE, UPDATE_FILTER_STATE, REPLACE_SELECTED_LIST, SEARCH_TEXT, SET_TAX_NAME } from "./TaxesMenuItems.actions";


export function TaxMenuItemReducer(state: ITaxesMenuItemState, action: { type: string, payload: any; }) {
    switch (action.type) {
        case SET_SELECTED_LIST:
            const list = [...state.selectedList];
            const item = action.payload;

            const index = list.findIndex((listItem: any) => listItem.id === item.id);

            if (index > -1) {
                list.splice(index, 1);
            } else {
                list.push(item);
            }
            return {
                ...state,
                selectedList: list
            };
        case SET_MENU_ITEM_LIST:
            const menuItemList = action.payload;
            return {
                ...state,
                itemList: menuItemList
            };
        case SET_FILTERS_STATE:
            const filterState: any = {};
            console.log(filterState);
            const filter = action.payload.map((subCat: any) => {
                filterState[subCat.id] = false;
                return {
                    key: subCat.id,
                    label: subCat.subcategory_name,
                    param: "subcategory_id",
                    expected: subCat.id
                };
            });
            const filterList = [{
                key: 'subcategories',
                label: 'subcategories',
                filters: filter
            }];
            return {
                ...state,
                filterState: {},
                filterList
            };
        case UPDATE_FILTER_STATE:
            const filtState = action.payload;
            return {
                ...state,
                filterState: filtState
            };
        case REPLACE_SELECTED_LIST:
            const newList = action.payload;
            return {
                ...state,
                selectedList: newList
            };
        case SEARCH_TEXT:
            const searchText = action.payload;
            return {
                ...state,
                searchText
            };
        case SET_TAX_NAME:
            const taxName = action.payload;
            return {
                ...state,
                taxName
            }
    }
    return state;
}